import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';

import { ConfigurationService } from '../configuration.service';


@Component({
    selector: 'itpx-configuration-add',
    templateUrl: './configuration-add.component.html',
    styleUrls: [ './configuration-add.component.css' ]
})

export class ConfigurationAddComponent implements OnInit {

    private fields: any[];
    private saveUrl: string;
    private cancelRoute: string = '/agora/configurations';

    constructor(
        private service: ConfigurationService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router
    ) { }

    ngOnInit() {
        this.saveUrl = this.configService.get('server').url + this.configService.get('endpoints').agora.configuration.add.api;
        this.fields = this.service.getAddFields();
    }

    private onSaveFinished() {
        this.router.navigate(['/agora/configurations']);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/configurations/add/configuration-add.component.ts